module.exports = __webpack_public_path__ + "img/co-host.20885071.svg";